function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M31.81 16l9.14-9.14A9.24 9.24 0 0154 6.88l2.61 2.61a9.24 9.24 0 010 13.06L42.26 36.92a9.24 9.24 0 01-13.06 0l-2.61-2.61",
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 5
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M31.81 47.37l-9.14 9.14a9.24 9.24 0 01-13.06 0L7 53.9a9.24 9.24 0 010-13.06l14.36-14.37a9.24 9.24 0 0113.06 0L37 29.09",
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 5
});

function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgdmlld0JveD0iMCAwIDY0IDY0Ij48dGl0bGU+bGluazwvdGl0bGU+PHBhdGggZD0iTTMxLjgxLDE2bDkuMTQtOS4xNEE5LjI0LDkuMjQsMCwwLDEsNTQsNi44OGwyLjYxLDIuNjFhOS4yNCw5LjI0LDAsMCwxLDAsMTMuMDZMNDIuMjYsMzYuOTJhOS4yNCw5LjI0LDAsMCwxLTEzLjA2LDBsLTIuNjEtMi42MSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLXdpZHRoPSI1Ii8+PHBhdGggZD0iTTMxLjgxLDQ3LjM3bC05LjE0LDkuMTRhOS4yNCw5LjI0LDAsMCwxLTEzLjA2LDBMNyw1My45QTkuMjQsOS4yNCwwLDAsMSw3LDQwLjg0TDIxLjM2LDI2LjQ3YTkuMjQsOS4yNCwwLDAsMSwxMy4wNiwwTDM3LDI5LjA5IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2Utd2lkdGg9IjUiLz48L3N2Zz4=";
export { SvgLink as ReactComponent };